// import styles from "./userprofile.module.css";
// import { Outlet, useLocation } from "react-router-dom";
// import { Banner, BreadCrumb } from "../../../components/shared/index";
// import UserSideBar from "./UserSideBar/UserSideBar";

// const UserProfileOverview = () => {
//   const { pathname } = useLocation();

//   // Get current route name
//   const parts = pathname.split("/").filter(Boolean);

//   // Example:
//   // /profile/orders  -> orders
//   const currentPage = parts[parts.length - 1];

//   // Route label mapping
//   const breadcrumbMap = {
//     profile: "Profile",
//     orders: "Orders",
//     address: "Address",
//     wishlist: "Wishlist",
//     settings: "Settings",
//   };

//   // Only show current page after Home
//   const customPaths = [
//     {
//       label: breadcrumbMap[currentPage] || currentPage,
//       path: pathname,
//     },
//   ];

//   return (
//     <section className={styles.userprofile__wrapper}>
//       <BreadcrumbBanner
//         customPaths={customPaths}
//         heading="Glow from within . Discover our new range of skin supplements and vitamins"
//         imageUrl="https://t4.ftcdn.net/jpg/03/31/74/45/240_F_331744543_PmdCacPCd5RpqNfffZ2BT2VgwlHQfibv.jpg"
//       />

//       <div className={styles.profileContentWrapper}>
//         <div className={styles.userSideBar}>
//           <UserSideBar />
//         </div>

//         <div className={styles.rightSection}>
//           <Outlet />
//         </div>
//       </div>
//     </section>
//   );
// };

// const BreadcrumbBanner = ({ customPaths, heading, imageUrl }) => (
//   <>
//     <BreadCrumb customPaths={customPaths} />
//     <Banner heading={heading} imageUrl={imageUrl} />
//   </>
// );

// export default UserProfileOverview;


// import styles from "./userprofile.module.css";
// import { Outlet, useLocation } from "react-router-dom";
// import { Banner, BreadCrumb } from "../../../components/shared/index";
// import UserSideBar from "./UserSideBar/UserSideBar";
// const UserProfileOverview = () => {
//   const { pathname } = useLocation();
//   const parts = pathname.split("/");
// const newPath = parts[parts.length - 1];

//   return (
//     <section className={styles.userprofile__wrapper}>
//       <BreadcrumbBanner
//         newPath={newPath}
//         heading="Purely Goodness . discover our curated range of certified organic products"
//         imageUrl="https://t4.ftcdn.net/jpg/06/52/85/05/240_F_652850507_uWaMSNheCIQZBEBGU4vLapGeRxn2nP08.jpg"
//       />

//       <div className={styles.profileContentWrapper}>
//         <div className={styles.userSideBar}>
//           <UserSideBar />
//         </div>

//         <div className={styles.rightSection}>
//           <Outlet />
//         </div>
//       </div>
//     </section>
//   );
// };

// const BreadcrumbBanner = ({ newPath, heading, imageUrl }) => {
//   const labelMap = {
//     profile: "Profile",
//     order: "Orders",
//     wishlist: "Wishlist",
//     address: "My Address",
//   };

//   const displayLabel = labelMap[newPath] || "Profile";

//   return (
//     <>
//       <BreadCrumb customPaths={[{ label: displayLabel, path: newPath }]} />
//       <Banner heading={heading} imageUrl={imageUrl} />
//     </>
//   );
// };

// export default UserProfileOverview;


import styles from "./userprofile.module.css";
import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";
import { Banner, BreadCrumb } from "../../../components/shared/index";
import UserSideBar from "./UserSideBar/UserSideBar";

const UserProfileOverview = () => {
  const { pathname } = useLocation();

  // Get current route name
  const parts = pathname.split("/").filter(Boolean);

  // Example:
  // /profile/orders  -> orders
  const currentPage = parts[parts.length - 1];

  // Route label mapping
  const breadcrumbMap = {
    profile: "Profile",
    orders: "Orders",
    address: "Address",
    wishlist: "Wishlist",
    settings: "Settings",
  };

  // Only show current page after Home
  const customPaths = [
    {
      label: breadcrumbMap[currentPage] || currentPage,
      path: pathname,
    },
  ];

  return (
    <section className={styles.userprofile__wrapper}>
      {/* <BreadcrumbBanner
        customPaths={customPaths}
        heading="Stay organized with a personalized account designed to make your shopping experience simple and convenient"
        imageUrl="https://t4.ftcdn.net/jpg/03/31/74/45/240_F_331744543_PmdCacPCd5RpqNfffZ2BT2VgwlHQfibv.jpg"
      /> */}

  <div className={styles.profileContentWrapper}>
        <div className={styles.userSideBar}>
          <UserSideBar />
        </div>

        <div className={styles.rightSection}>
          <Outlet />
        </div>
      </div>
    </section>
  );
};

const BreadcrumbBanner = ({ customPaths, heading, imageUrl }) => (
  <>
    <BreadCrumb customPaths={customPaths} />
    <Banner heading={heading} imageUrl={imageUrl} />
  </>
);

export default UserProfileOverview;
